webpackJsonp([24],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "5W1q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6VMs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AZp9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N+zL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-awesome-swiper/src/slide.vue


/* harmony default export */ var slide = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-115f7cdb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-awesome-swiper/src/slide.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.slideClass},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_slide = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-awesome-swiper/src/slide.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  slide,
  src_slide,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vue_awesome_swiper_src_slide = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue


/* harmony default export */ var App = ({
  name: 'APP'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f3f88a64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/router/index.js



var Login = function Login() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(22)]).then(__webpack_require__.bind(null, "W2Q3"));
};
var Register = function Register() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(__webpack_require__.bind(null, "NTb/"));
};
var Index = function Index() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(__webpack_require__.bind(null, "ARoL"));
};
var Layout = function Layout() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, "AkUR"));
};
var GoodsList = function GoodsList() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(__webpack_require__.bind(null, "5/7D"));
};
var Details = function Details() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(__webpack_require__.bind(null, "0Tli"));
};
var Discount = function Discount() {
    return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "Aka/"));
};
var Strategy = function Strategy() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(__webpack_require__.bind(null, "tlgn"));
};
var ModlueClassify = function ModlueClassify() {
    return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "3Fj/"));
};
var Clothing01 = function Clothing01() {
    return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "WZEA"));
};
var Shopping = function Shopping() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, "HQIK"));
};
var StrategyDetail = function StrategyDetail() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(__webpack_require__.bind(null, "2axa"));
};
var Clothing = function Clothing() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(__webpack_require__.bind(null, "X4u6"));
};
var PurchaseNote = function PurchaseNote() {
    return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "T3Zi"));
};
var Result = function Result() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(__webpack_require__.bind(null, "4sCl"));
};
var Settlement = function Settlement() {
    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "iyM9"));
};

var CashierDesk = function CashierDesk() {
    return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "M1O+"));
};
var Forget = function Forget() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(21)]).then(__webpack_require__.bind(null, "H0Tk"));
};
var CustomMade = function CustomMade() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, "REW0"));
};
var Coupon = function Coupon() {
    return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "Vk0n"));
};

var Modification = function Modification() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(20)]).then(__webpack_require__.bind(null, "bNry"));
};
var Introduce = function Introduce() {
    return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(__webpack_require__.bind(null, "/faj"));
};

vue_esm["default"].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
    scrollBehavior: function scrollBehavior() {
        return { y: 0 };
    },
    routes: [{
        path: '*',
        redirect: '/dashboard/index'
    }, {
        path: '/dashboard',
        component: Layout,
        redirect: '/dashboard/index',
        name: '首页',
        children: [{ path: 'index', component: Index, name: '首页' }, { path: 'customMade', component: CustomMade, name: '定制' }, { path: 'goodsList', component: GoodsList, name: '商品列表页' }, { path: 'details', component: Details, name: '商品详情页' }, { path: 'discount', component: Discount, name: '拼采' }, { path: 'strategy', component: Strategy, name: '攻略' }, { path: 'strategyDetail', component: StrategyDetail, name: '攻略详情' }, { path: 'clothing', component: Clothing, name: '服装' }, { path: 'introduce', component: Introduce, name: '公司介绍' }]
    }, {
        path: '/result',
        component: Result,
        redirect: '/result/purchaseNote',
        name: '结算',
        children: [{ path: 'purchaseNote', component: PurchaseNote, name: '我的采购页' }, { path: 'settlement', component: Settlement, name: '结算页' }, { path: 'register', component: Register, name: '欢迎注册' }, { path: 'cashierDesk', component: CashierDesk, name: '收银台' }, { path: 'shopping', component: Shopping, name: '我的采购单' }, { path: 'login', component: Login, name: '登录页' }, { path: 'forget', component: Forget, name: '忘记密码' }, { path: 'coupon', component: Coupon, name: '领取优惠劵' }, { path: 'modification', component: Modification, name: '修改密码' }]
    }]
}));
// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__("j1ja");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/nprogress/nprogress.js
var nprogress = __webpack_require__("Y81h");
var nprogress_default = /*#__PURE__*/__webpack_require__.n(nprogress);

// EXTERNAL MODULE: ./node_modules/nprogress/nprogress.css
var nprogress_nprogress = __webpack_require__("UVIz");
var nprogress_nprogress_default = /*#__PURE__*/__webpack_require__.n(nprogress_nprogress);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/element-ui.common.js
var element_ui_common = __webpack_require__("zL8q");
var element_ui_common_default = /*#__PURE__*/__webpack_require__.n(element_ui_common);

// EXTERNAL MODULE: ./node_modules/element-ui/lib/theme-chalk/index.css
var theme_chalk = __webpack_require__("tvR6");
var theme_chalk_default = /*#__PURE__*/__webpack_require__.n(theme_chalk);

// EXTERNAL MODULE: ./node_modules/vue-photo-preview/dist/vue-photo-preview.js
var vue_photo_preview = __webpack_require__("ibnl");
var vue_photo_preview_default = /*#__PURE__*/__webpack_require__.n(vue_photo_preview);

// EXTERNAL MODULE: ./node_modules/vue-photo-preview/dist/skin.css
var skin = __webpack_require__("tOCg");
var skin_default = /*#__PURE__*/__webpack_require__.n(skin);

// EXTERNAL MODULE: ./node_modules/area-data/data.js
var area_data_data = __webpack_require__("BI0u");
var data_default = /*#__PURE__*/__webpack_require__.n(area_data_data);

// EXTERNAL MODULE: ./node_modules/vue-area-linkage/dist/index.js
var dist = __webpack_require__("Yg9U");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./node_modules/vue-area-linkage/dist/index.css
var vue_area_linkage_dist = __webpack_require__("wtQg");
var vue_area_linkage_dist_default = /*#__PURE__*/__webpack_require__.n(vue_area_linkage_dist);

// EXTERNAL MODULE: ./node_modules/animate.css/animate.css
var animate = __webpack_require__("oPmM");
var animate_default = /*#__PURE__*/__webpack_require__.n(animate);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/vue-awesome-swiper/index.js
var vue_awesome_swiper = __webpack_require__("F3EI");
var vue_awesome_swiper_default = /*#__PURE__*/__webpack_require__.n(vue_awesome_swiper);

// EXTERNAL MODULE: ./node_modules/swiper/dist/css/swiper.css
var swiper = __webpack_require__("v2ns");
var swiper_default = /*#__PURE__*/__webpack_require__.n(swiper);

// CONCATENATED MODULE: ./src/api/index.js



var REFRESH_TOKEN_URL = '/uac/auth/user/refreshToken';
function refreshToken() {
    return axios_default()({
        method: 'GET',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        url: REFRESH_TOKEN_URL,
        auth: {
            username: 'paascloud-client-uac',
            password: 'paascloudClientSecret'
        },
        params: {
            refreshToken: store.getters.getRefreshToken,
            accessToken: store.getters.getAccessToken
        }
    });
}
function getUserInfo(token) {
    return vue_esm["default"].prototype.$http({
        method: 'post',
        headers: {
            'deviceId': new Date().getTime(),
            "Authorization": 'Bearer ' + token
        },
        url: 'uac/user/getInformation'
    });
}
function loginOut(token) {
    return vue_esm["default"].prototype.$http({
        method: 'post',
        headers: {
            'deviceId': new Date().getTime(),
            "Authorization": 'Bearer ' + token
        },
        url: '/uac/user/logout',
        data: { 'accessToken': token }
    });
}
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("lbHh");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// CONCATENATED MODULE: ./src/utils/cookie/index.js


var TokenKey = 'Admin-Token';

function getToken() {
    return js_cookie_default.a.get(TokenKey);
}

function setToken(token) {
    return js_cookie_default.a.set(TokenKey, token);
}

function removeToken() {
    return js_cookie_default.a.remove(TokenKey);
}
// CONCATENATED MODULE: ./src/utils/storage/index.js

var setStore = function setStore(name, content) {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
};

var getStore = function getStore(name) {
    if (!name) return;
    return window.localStorage.getItem(name);
};

var removeStore = function removeStore(name) {
    if (!name) return;
    window.localStorage.removeItem(name);
};
// CONCATENATED MODULE: ./src/store/user/index.js



var user_state = {
    loginName: getStore('loginName'),
    rememberMe: false,
    menuList: [],
    redirectUri: '',
    token: getToken(),
    cartList: getStore('buyCart'),
    orderList: getStore('orderList'),
    stratetyList: getStore('stratetyList'),
    spellList: getStore('spellList'),
    isLogin: false,
    isStatement: false,
    sheetList: [],
    authToken: {
        access_token: '',
        expires_in: '',
        timestamp: ''
    },
    refreshToken: {
        refresh_token: ''
    }
};

var mutations = {
    SET_SHEETLIST: function SET_SHEETLIST(state, sheetList) {
        state.sheetList = sheetList;
    },
    SET_ISLOGIN: function SET_ISLOGIN(state, isLogin) {
        state.isLogin = isLogin;
    },
    SET_ISSTATEMENT: function SET_ISSTATEMENT(state, isStatement) {
        state.isStatement = isStatement;
    },
    SET_CODE: function SET_CODE(state, code) {
        state.code = code;
    },
    SET_TOKEN: function SET_TOKEN(state, token) {
        state.token = token;
    },
    SET_STRATETYLIST: function SET_STRATETYLIST(state, stratetyList) {
        state.stratetyList = stratetyList;
    },
    SET_SPELLLIST: function SET_SPELLLIST(state, spellList) {
        state.spellList = spellList;
    },
    SET_CARLIST: function SET_CARLIST(state, cartList) {
        state.cartList = cartList;
    },
    SET_ORDERLIST: function SET_ORDERLIST(state, orderList) {
        state.orderList = orderList;
    },
    SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
        state.introduction = introduction;
    },
    SET_SETTING: function SET_SETTING(state, setting) {
        state.setting = setting;
    },
    SET_STATUS: function SET_STATUS(state, status) {
        state.status = status;
    },
    SET_LOGINNAME: function SET_LOGINNAME(state, loginName) {
        state.loginName = loginName;
    },
    SET_AVATAR: function SET_AVATAR(state, avatar) {
        state.avatar = avatar;
    },
    SET_ROLES: function SET_ROLES(state, roles) {
        state.roles = roles;
    }
};

var actions = {
    get_access_token: function get_access_token(_ref, cb) {
        var commit = _ref.commit;

        cb && cb(user_state.token);
    },
    set_sheet_list: function set_sheet_list(_ref2, sheetList) {
        var commit = _ref2.commit;

        commit('SET_SHEETLIST', sheetList);
        setStore('sheetList', sheetList);
    },
    update_auth_token: function update_auth_token(_ref3, authToken) {
        var commit = _ref3.commit;

        user_state.authToken = authToken;
        commit('SET_TOKEN', authToken.access_token);
        console.log(11111111, authToken.access_token);
        commit('SET_LOGINNAME', authToken.loginName);
        setStore('loginName', authToken.loginName);

        setToken(authToken.access_token);
    },
    delete_user_info: function delete_user_info(_ref4, loginName) {
        var commit = _ref4.commit;

        removeToken();
        commit('SET_TOKEN', '');
        removeStore('buyCart');
        commit('SET_CARLIST', '');
        commit('SET_LOGINNAME', '');
        removeStore('loginName');
    },
    GetUserInfo: function GetUserInfo(_ref5) {
        var commit = _ref5.commit,
            state = _ref5.state;

        return new Promise(function (resolve, reject) {
            getUserInfo(state.token).then(function (response) {
                if (!response.data) {
                    reject('error');
                }
                var data = response.result;

                commit('SET_LOGINNAME', data.loginName);
                setStore('loginName', data.loginName);

                resolve(response);
            }).catch(function (error) {

                console.log(error);
                reject(error);
            });
        });
    },
    LoginOut: function LoginOut(_ref6) {
        var commit = _ref6.commit,
            state = _ref6.state;

        return new Promise(function (resolve, reject) {
            loginOut(state.token).then(function (response) {
                removeToken();
                commit('SET_TOKEN', '');
                removeStore('buyCart');
                commit('SET_CARLIST', '');
                commit('SET_LOGINNAME', '');
                removeStore('loginName');
            }).catch(function (error) {

                console.log(error);
                reject(error);
            });
        });
    },
    add_strategy_list: function add_strategy_list(_ref7, strategyForm) {
        var commit = _ref7.commit;

        commit('SET_STRATETYLIST', JSON.stringify(strategyForm));
        setStore('stratetyList', strategyForm);
    },
    remove_strategy_List: function remove_strategy_List(_ref8) {
        var commit = _ref8.commit;

        commit('SET_STRATETYLIST', '');
        setStore('stratetyList', '');
        removeStore('stratetyList');
    },
    add_spell_list: function add_spell_list(_ref9, spellForm) {
        var commit = _ref9.commit;

        commit('SET_SPELLLIST', JSON.stringify(spellForm));
        setStore('spellList', spellForm);
    },
    remove_spell_List: function remove_spell_List(_ref10) {
        var commit = _ref10.commit;

        commit('SET_SPELLLIST', '');
        setStore('spellList', '');
        removeStore('spellList');
    },
    add_cart_list: function add_cart_list(_ref11, localData) {
        var commit = _ref11.commit;

        var cart = [];
        if (user_state.cartList) {
            cart = JSON.parse(user_state.cartList) || [];
        }
        var falg = true;
        var goods = localData;
        console.log(34343, goods);
        if (cart.length != 0) {
            cart.forEach(function (item) {
                if (item.productId === goods.productId && item.skuId == goods.skuId && item.made == goods.made) {
                    if (item.quantity >= 0) {
                        falg = false;
                        item.quantity = parseInt(item.quantity);
                        item.quantity += parseInt(goods.quantity);
                    }
                }
            });
        }
        if (!cart.length || falg) {
            goods.checked = '1';
            cart.push(goods);
        }
        console.log(3435453, cart);
        commit('SET_CARLIST', JSON.stringify(cart));
        setStore('buyCart', cart);
    },
    update_cart_list: function update_cart_list(_ref12, list) {
        var commit = _ref12.commit;

        var localData = JSON.parse(list);
        localData.forEach(function (item, index) {
            if (item.checked || item.checked == 1) {
                item.checked = 1;
            } else {
                item.checked = 0;
            }
        });
        if (localData.length == 0) {
            setStore('buyCart', '');
            removeStore('buyCart');
            return;
        }
        setStore('buyCart', localData);
        setStore('buyCart', localData);
    },
    remove_car_List: function remove_car_List(_ref13, list) {
        var commit = _ref13.commit;

        setStore('buyCart', '');
        removeStore('buyCart');
    },
    set_order_list: function set_order_list(_ref14, orderList) {
        var commit = _ref14.commit;

        commit('SET_ORDERLIST', JSON.stringify(orderList));
        setStore('orderList', orderList);
    },
    remove_order_list: function remove_order_list(_ref15, list) {
        var commit = _ref15.commit;

        setStore('orderList', '');
        removeStore('orderList');
    }
};

function jumpLoginPage() {
    if (true) {
        window.location.href = 'http://login.paascloud.net/login';
    } else {
        window.location.href = 'http://dev-login.paascloud.net/login';
    }
}

/* harmony default export */ var user = ({
    state: user_state,
    actions: actions,
    mutations: mutations
});
// CONCATENATED MODULE: ./src/store/global/index.js
var global_state = {
    ajaxLoading: false,
    buttonLoading: false,
    isTool: '',
    isActive: -1,
    notice: {
        show: false,
        options: {
            autoClose: false,
            countdownBar: false,
            content: 'notice content'
        }
    }
};

var getters = {
    getAjaxLoading: function getAjaxLoading(state) {
        return state.ajaxLoading;
    },
    getButtonLoading: function getButtonLoading(state) {
        return state.buttonLoading;
    },
    getNoticeShow: function getNoticeShow(state) {
        return state.notice.show;
    },
    getNoticeOptions: function getNoticeOptions(state) {
        return state.notice.options;
    },
    istool: function istool(state) {
        return state.istool;
    },
    isActive: function isActive(state) {
        return state.isActive;
    }
};

var global_mutations = {
    SET_ISTOOL: function SET_ISTOOL(state, isTool) {
        state.isTool = isTool;
    },
    SET_ISACTIVE: function SET_ISACTIVE(state, isActive) {
        state.isActive = isActive;
    },
    showAjaxLoading: function showAjaxLoading(state) {
        state.ajaxLoading = true;
    },
    hideAjaxLoading: function hideAjaxLoading(state) {
        state.ajaxLoading = false;
    },
    showButtonLoading: function showButtonLoading(state) {
        state.buttonLoading = true;
    },
    hideButtonLoading: function hideButtonLoading(state) {
        state.buttonLoading = false;
    },
    newNotice: function newNotice(state, options) {
        state.notice.show = true;
        state.notice.options = options;
    },
    closeNotice: function closeNotice(state) {
        state.notice.show = false;
        state.notice.options = {};
    }
};

var global_actions = {
    show_ajaxLoading: function show_ajaxLoading(_ref) {
        var commit = _ref.commit;

        return new Promise(function (resolve, reject) {
            commit('showAjaxLoading');
            resolve();
        });
    },
    hide_ajaxLoading: function hide_ajaxLoading(_ref2) {
        var commit = _ref2.commit;

        return new Promise(function (resolve, reject) {
            commit('hideAjaxLoading');
            resolve();
        });
    },
    show_buttonLoading: function show_buttonLoading(_ref3) {
        var commit = _ref3.commit;

        return new Promise(function (resolve, reject) {
            commit('showButtonLoading');
            resolve();
        });
    },
    hide_buttonLoading: function hide_buttonLoading(_ref4) {
        var commit = _ref4.commit;

        return new Promise(function (resolve, reject) {
            commit('hideButtonLoading');
            resolve();
        });
    },
    new_notice: function new_notice(_ref5, options) {
        var commit = _ref5.commit;

        commit('newNotice', options);
    },
    close_notice: function close_notice(_ref6) {
        var commit = _ref6.commit;

        commit('closeNotice');
    }
};

/* harmony default export */ var global = ({
    state: global_state,
    getters: getters,
    actions: global_actions,
    mutations: global_mutations
});
// CONCATENATED MODULE: ./src/store/getters.js
var _getters;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getters_getters = (_getters = {
    token: function token(state) {
        return state.user.token;
    },
    avatar: function avatar(state) {
        return state.user.avatar;
    },
    loginName: function loginName(state) {
        return state.loginName;
    },
    cartList: function cartList(state) {
        return state.cartList;
    },
    orderList: function orderList(state) {
        return state.orderList;
    },
    stratetyList: function stratetyList(state) {
        return state.stratetyList;
    },
    sheetList: function sheetList(state) {
        return state.sheetList;
    }
}, _defineProperty(_getters, "token", function token(state) {
    return state.token;
}), _defineProperty(_getters, "isLogin", function isLogin(state) {
    return state.isLogin;
}), _defineProperty(_getters, "isStatement", function isStatement(state) {
    return state.isStatement;
}), _defineProperty(_getters, "introduction", function introduction(state) {
    return state.user.introduction;
}), _defineProperty(_getters, "status", function status(state) {
    return state.user.status;
}), _defineProperty(_getters, "roles", function roles(state) {
    return state.user.roles;
}), _defineProperty(_getters, "setting", function setting(state) {
    return state.user.setting;
}), _getters);
/* harmony default export */ var store_getters = (getters_getters);
// CONCATENATED MODULE: ./src/store/index.js







vue_esm["default"].use(vuex_esm["a" /* default */]);
vue_esm["default"].prototype.$http = axios_default.a.create({
    timeout: 60000
});

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
    modules: {
        user: user,
        global: global,
        getters: store_getters
    }
}));
// EXTERNAL MODULE: ./node_modules/vue-lazyload/vue-lazyload.js
var vue_lazyload = __webpack_require__("cTzj");
var vue_lazyload_default = /*#__PURE__*/__webpack_require__.n(vue_lazyload);

// EXTERNAL MODULE: ./node_modules/vue-infinite-scroll/vue-infinite-scroll.js
var vue_infinite_scroll = __webpack_require__("bqTm");
var vue_infinite_scroll_default = /*#__PURE__*/__webpack_require__.n(vue_infinite_scroll);

// EXTERNAL MODULE: ./node_modules/font-awesome/css/font-awesome.css
var font_awesome = __webpack_require__("5W1q");
var font_awesome_default = /*#__PURE__*/__webpack_require__.n(font_awesome);

// CONCATENATED MODULE: ./src/mixins/index.js
var mixin = {
  data: function data() {
    return {};
  },

  methods: {
    getUrlParam: function getUrlParam(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
      var result = window.location.search.substr(1).match(reg);
      return result ? decodeURIComponent(result[2]) : null;
    },
    loadPage: function loadPage(routerName, param) {
      if (param) {
        this.$router.push({ name: routerName, query: param });
      } else {
        this.$router.push({ name: routerName });
      }
    },
    successTips: function successTips(msg) {
      this.$store.dispatch('new_notice', {
        autoClose: true,
        content: msg || '操作成功！'
      });
    },
    errorTips: function errorTips(msg) {
      this.$store.dispatch('new_notice', {
        autoClose: true,
        content: msg || '哪里不对了~'
      });
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    goHome: function goHome() {
      this.loadPage('Index');
    },
    successMsg: function successMsg(msg, showClose) {
      this.message(msg, 'success', showClose);
    },
    errorMsg: function errorMsg(msg, showClose) {
      this.message(msg, 'error', showClose);
    },
    warnMsg: function warnMsg(msg, showClose) {
      this.message(msg, 'warning', showClose);
    },
    message: function message(msg, type, showClose) {
      this.$message({
        showClose: showClose || false,
        message: msg,
        type: type
      });
    },
    confirmModel: function confirmModel(message, url, param, callback) {
      this.ajaxBox({
        url: url,
        data: param || '',
        message: message,
        success: callback
      });
    },
    ajax: function ajax(param) {
      var _this = this;

      var type = param.type,
          url = param.url,
          data = param.data,
          success = param.success,
          isUnMusk = param.isUnMusk,
          loading = param.loading;

      if (!isUnMusk) {
        this.$pcNProgress.start();
      }
      if (loading && !this.$store.getters.getAjaxLoading) {
        this.$store.dispatch('show_ajaxLoading');
      }
      if (loading && !this.$store.getters.getButtonLoading) {
        this.$store.dispatch('show_buttonLoading');
      }
      this.$http({
        method: type || 'POST',
        url: url || '',
        data: data || ''
      }).then(function (res) {
        _this.$pcNProgress.done();
        if (loading && _this.$store.getters.getAjaxLoading) {
          _this.$store.dispatch('hide_ajaxLoading');
        }
        if (loading && _this.$store.getters.getButtonLoading) {
          _this.$store.dispatch('hide_buttonLoading');
        }
        if (success) {
          success(res);
        } else {
          _this.goBack();
        }
      }).catch(function (error) {
        _this.$pcNProgress.done();
        _this.$loading = false;
        if (loading && _this.$store.getters.getAjaxLoading) {
          _this.$store.dispatch('hide_ajaxLoading');
        }
        if (loading && _this.$store.getters.getButtonLoading) {
          _this.$store.dispatch('hide_buttonLoading');
        }
        console.error(error);
      });
    },
    ajaxBox: function ajaxBox(param) {
      var _this2 = this;

      var type = param.type,
          data = param.data,
          url = param.url,
          message = param.message,
          success = param.success,
          iconType = param.iconType,
          confirmButtonText = param.confirmButtonText,
          cancelButtonText = param.cancelButtonText,
          title = param.title;

      if (!message) {
        alert('必须输入提示信息!');
        return;
      }
      var response = void 0;
      this.$pcMessageBox({
        title: title || '消息',
        message: message,
        showCancelButton: true,
        confirmButtonText: confirmButtonText || '确定',
        cancelButtonText: cancelButtonText || '取消',
        type: iconType || 'warning',
        closeOnPressEscape: true,
        beforeClose: function beforeClose(action, instance, done) {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;

            _this2.ajax({
              type: type,
              url: url,
              data: data,
              success: function success(res) {
                done();
                response = res;
              }
            });
            setTimeout(function () {
              instance.confirmButtonLoading = false;
            }, 400);
          } else {
            done();
          }
        }
      }).then(function () {
        if (success) {
          success(response);
        }
      }).catch(function (error) {
        console.error(error);
      });
    },
    validate: function validate(value, type) {
      if (type === 'require') {
        return !!value;
      }

      if (type === 'phone') {
        return (/^1\d{10}$/.test(value)
        );
      }

      if (type === 'email') {
        return (/^(\w)+(\.\w+)*@(\w)+((\.\w{2,3}){1,3})$/.test(value)
        );
      }
      if (type === 'pwd') {
        return (/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,14}$/.test(value)
        );
      }
    }
  }
};

/* harmony default export */ var mixins = (mixin);
// CONCATENATED MODULE: ./src/vueBus.js

/* harmony default export */ var vueBus = (new vue_esm["default"]());
// EXTERNAL MODULE: ./src/filters/index.js
var filters = __webpack_require__("Q0Ca");
var filters_default = /*#__PURE__*/__webpack_require__.n(filters);

// EXTERNAL MODULE: ./src/style/common.css
var common = __webpack_require__("kXGG");
var common_default = /*#__PURE__*/__webpack_require__.n(common);

// EXTERNAL MODULE: ./src/style/elementUI.css
var elementUI = __webpack_require__("AZp9");
var elementUI_default = /*#__PURE__*/__webpack_require__.n(elementUI);

// EXTERNAL MODULE: ./src/style/style.css
var style = __webpack_require__("gQNZ");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./src/style.less
var src_style = __webpack_require__("6VMs");
var src_style_default = /*#__PURE__*/__webpack_require__.n(src_style);

// CONCATENATED MODULE: ./src/main.js






































vue_esm["default"].use(vue_photo_preview_default.a);

vue_esm["default"].use(animate_default.a);
vue_esm["default"].prototype.$pca = area_data_data["pca"];
vue_esm["default"].prototype.$pcaa = area_data_data["pcaa"];
vue_esm["default"].use(dist_default.a);

var components = [element_ui_common["Dialog"]];
components.map(function (component) {
  vue_esm["default"].component(component.name, component);
});
vue_esm["default"].prototype.$ELEMENT = { size: 'small' };
vue_esm["default"].use(element_ui_common["Loading"].directive);
vue_esm["default"].prototype.$pcLoading = element_ui_common["Loading"].service;
vue_esm["default"].prototype.$pcMessageBox = element_ui_common["MessageBox"];
vue_esm["default"].prototype.$pcMessage = element_ui_common["Message"];
vue_esm["default"].prototype.$confirm = element_ui_common["MessageBox"].confirm;
vue_esm["default"].prototype.$pcNProgress = nprogress_default.a;
vue_esm["default"].prototype.$pcBus = vueBus;


vue_esm["default"].prototype.$http = axios_default.a.create({
  timeout: 60000
});

if (true) {
  vue_esm["default"].prototype.$http.defaults.baseURL = 'https://www.jdcai.com/bus';
}

vue_esm["default"].prototype.$http.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  console.log(error);
  Promise.reject(error);
});

vue_esm["default"].prototype.$http.interceptors.response.use(function (res) {
  if (res.data.code === 200) {
    return res.data;
  } else {
    Object(element_ui_common["Message"])({
      message: res.data.message,
      type: 'warning',
      duration: 5 * 1000
    });
    return res.data;
  }
}, function (error) {
  var options = {
    autoClose: true,
    content: error.response.data.message
  };
  if (error.response) {
    console.log('error: ', error.response);
    if (error.response.status === 401) {

      Object(element_ui_common["Message"])({
        message: '登陆超时',
        type: 'error',
        duration: 5 * 1000
      });

      store.dispatch('delete_user_info').then(function () {
        router.push({ path: '/result/login' });
        location.reload();
      });
    } else {
      Object(element_ui_common["Message"])({
        message: error.response.data.message,
        type: 'error',
        duration: 5 * 1000
      });
      return error.response.data;
    }
  } else {
    options.content = '接口请求失败或超时！请刷新重试';
  }
  store.dispatch('new_notice', options);
});

router.beforeEach(function (to, from, next) {
  nprogress_default.a.start();

  console.log(4444444, to.path);
  if (to.path === '/result/login' || to.path == '/dashboard/index') {
    next();
    nprogress_default.a.done();
  } else {
    store.dispatch('get_access_token', function (res) {
      if (res) {
        store.dispatch('GetUserInfo', res).then(function (response) {
          next();
        }).catch(function (err) {
          next();
        });
      } else {
        nprogress_default.a.start();
        next();
      }
    });
  }
});
router.afterEach(function (transition) {
  var lists = document.getElementsByClassName('mouse-cover-canvas');
  for (var i = 0, j = lists.length; i < j; i++) {
    if (lists[i]) {
      lists[i].style.display = 'none';
    }
  }
  nprogress_default.a.done();
});

vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(element_ui_common_default.a);
vue_esm["default"].use(vuex_esm["a" /* default */]);
vue_esm["default"].use(vue_awesome_swiper_default.a);

vue_esm["default"].use(vue_lazyload_default.a, {
  preLoad: 1.3,
  error: '/static/loading-svg/loading-bars.svg',
  loading: '/static/loading-svg/loading-spinning-bubbles.svg',
  attempt: 2
});
vue_esm["default"].use(vue_infinite_scroll_default.a);
vue_esm["default"].mixin(mixins);

Object.keys(filters_default.a).forEach(function (k) {
  return vue_esm["default"].filter(k, filters_default.a[k]);
});
new vue_esm["default"]({
  router: router,
  store: store,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app');

/***/ }),

/***/ "Q0Ca":
/***/ (function(module, exports) {

exports.getUserStatusName = function (state) {
  var statusName = '';
  switch (state) {
    case 'ENABLE':
      {
        state = '启用';
        break;
      }
    case 'DISABLE':
      {
        state = '禁用';
        break;
      }
  }
  return statusName;
};

/***/ }),

/***/ "UVIz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gQNZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kXGG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPmM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pYmz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-awesome-swiper/src/swiper.vue


var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__("m0SV");
/* harmony default export */ var swiper = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e617127","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-awesome-swiper/src/swiper.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-container"},[_vm._t("parallax-bg"),_vm._v(" "),_c('div',{class:_vm.defaultSwiperClasses.wrapperClass},[_vm._t("default")],2),_vm._v(" "),_vm._t("pagination"),_vm._v(" "),_vm._t("button-prev"),_vm._v(" "),_vm._t("button-next"),_vm._v(" "),_vm._t("scrollbar")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_swiper = (esExports);
// CONCATENATED MODULE: ./node_modules/vue-awesome-swiper/src/swiper.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  swiper,
  src_swiper,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vue_awesome_swiper_src_swiper = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "tOCg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wtQg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.2a70c1fe693a343edc94.js